export enum BuyerListingDislikeReason {
  PRICE_TOO_HIGH = 'Price too High',
  MOV_MOQ_TOO_HIGH = 'MOV/MOQ too high',
  INTERNATIONAL_SHIPPING = 'International Shipping',
  DELIVERY_TOO_LONG = 'Delivery too long',
  PRODUCT_SELECTION = 'Product Selection',
  OTHER = 'Other',
}
